import { BaseEntity } from '../../../models';
import { contatoSituacaoAtivo } from './situacao';

export class PessoaContato implements BaseEntity {
    readonly id: number;
    idPessoa: number;
    tipo: number;
    situacao: number;
    nome: string;
    fone: string;
    celular: string;
    email: string;
    anotacao: string;

    constructor(tipo: number = null) {
        this.tipo = tipo;
        this.situacao = contatoSituacaoAtivo.id;
    }
}
